module.exports = __webpack_public_path__ + "static/media/howwork-hover2-3.3c105b37.svg";